export default "__VITE_ASSET__DT22rQWJ__"